import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonComponentModule } from './common-components/common-components.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CommonComponentModule
  ],
  exports: [CommonComponentModule, CommonModule],
  providers: []
})
export class SharedUIModule { }
